(() => {
  const DATA = window.EDU_LIBRARY;
  const root = document.getElementById('biblioteca-edu');
  if (!root || !DATA) return;

  const lessons = DATA.lessons.map((lesson, index) => {
    const tax = DATA.taxonomy[lesson.area] || {};
    return {
      ...lesson,
      index,
      category: tax.category || '',
      subcategory: tax.subcategory || '',
      youtubeUrl: `https://www.youtube.com/watch?v=${lesson.video}`,
      thumbnail: `https://i.ytimg.com/vi/${lesson.video}/hqdefault.jpg`
    };
  });

  const sectionOrder = ['Biblioteca', 'Percorsi', 'Aperture', 'Mediogioco', 'Finali', 'Partite'];
  const areaSections = ['Aperture', 'Mediogioco', 'Finali', 'Partite'];
  const sectionIcons = {
    Biblioteca: '▣',
    Percorsi: '◎',
    Aperture: '♙',
    Mediogioco: '♞',
    Finali: '♔',
    Partite: '▦'
  };
  const preferredSubcategories = [
    '1.e4 Col Bianco', '1.d4 Col Bianco', 'Minori Col Bianco',
    '1.e4 Col Nero', '1.d4 Col Nero', 'Minori Col Nero',
    'Base', 'Intermedio', 'Avanzato', 'Intermedi',
    'Alto Livello', 'Allievi / Livello Intermedio'
  ];

  const grid = root.querySelector('#EduLibraryGrid');
  const sectionWrap = root.querySelector('#EduCategories');
  const detailPanel = root.querySelector('#EduSubcategories');
  const detailTitle = root.querySelector('#EduSubcategoriesTitle');
  const detailHint = root.querySelector('#EduSubcategoriesHint');
  const detailChips = root.querySelector('#EduSubcategoryChips');
  const search = root.querySelector('#EduLibrarySearch');
  const count = root.querySelector('#EduResultsCount');
  const empty = root.querySelector('#EduLibraryEmpty');
  const more = root.querySelector('#EduLoadMore');
  const reset = root.querySelector('#EduResetFilters');
  const emptyReset = root.querySelector('#EduEmptyReset');
  const activeFilters = root.querySelector('#EduActiveFilters');
  const activeFiltersList = root.querySelector('#EduActiveFiltersList');
  const totalHero = root.querySelector('[data-edu-total]');
  const libraryTotal = root.querySelector('[data-edu-library-total]');
  const sectionTotal = root.querySelector('[data-edu-section-total]');
  const pathList = root.querySelector('#EduPathList');

  /*
    MULTI-FILTER LOGIC
    ------------------
    - activeSections can contain more than one main section.
    - Different main sections are combined with AND.
      Example: Biblioteca + Aperture = only permanent opening lessons.
    - If the user combines incompatible sections (example: Aperture + Finali),
      the result can legitimately be zero lessons.
    - Detail filters narrow only their own section.
      Example: Aperture + "1.e4 Col Bianco" means opening lessons in that subcategory.
    - EVERY selected detail is also combined with AND.
      Example: Trompowsky + Ponziani only returns a lesson if it belongs to BOTH paths.
      If no lesson satisfies all selected filters, the result is correctly zero.
    - Text search remains an additional narrowing layer over the structured filters.
  */
  const activeSections = new Set();
  const activeDetails = new Map(); // section -> Set(detail values)
  let detailSection = null;        // last section whose detail panel is open
  let visibleLimit = 24;
  const LOAD_STEP = 10;

  const normalize = value => (value || '').toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const esc = value => (value || '').toString().replace(/[&<>'"]/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[ch]));

  function contrastText(hex) {
    const clean = (hex || '').replace('#', '');
    if (!/^[0-9a-f]{6}$/i.test(clean)) return '#111111';
    const r = parseInt(clean.slice(0, 2), 16);
    const g = parseInt(clean.slice(2, 4), 16);
    const b = parseInt(clean.slice(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.58 ? '#111111' : '#ffffff';
  }

  function pathName(code) {
    return DATA.paths?.[code]?.name || code;
  }

  function sectionCount(section) {
    if (section === 'Biblioteca') return lessons.filter(x => x.library).length;
    if (section === 'Percorsi') return lessons.filter(x => Array.isArray(x.paths) && x.paths.length).length;
    return lessons.filter(x => x.category === section).length;
  }

  function detailsFor(section) {
    if (!activeDetails.has(section)) activeDetails.set(section, new Set());
    return activeDetails.get(section);
  }

  if (totalHero) totalHero.textContent = lessons.length;
  if (libraryTotal) libraryTotal.textContent = lessons.filter(x => x.library).length;
  if (sectionTotal) sectionTotal.textContent = sectionOrder.length;

  function renderSections() {
    sectionWrap.innerHTML = sectionOrder.map(section => {
      const n = sectionCount(section);
      const active = activeSections.has(section) ? ' is-active' : '';
      const libraryClass = section === 'Biblioteca' ? ' edu-category--library' : '';
      const meta = section === 'Biblioteca'
        ? String(n) + ' lezioni permanenti'
        : section === 'Percorsi'
          ? `${Object.keys(DATA.paths || {}).length} percorsi`
          : `${n} lezioni`;
      const permanentBadge = section === 'Biblioteca'
        ? '<span class="edu-category__permanent">SEMPRE DISPONIBILI</span>'
        : '';
      return `<button class="edu-category${active}${libraryClass}" type="button" data-section="${esc(section)}" aria-pressed="${activeSections.has(section)}">
        <span class="edu-category__icon">${sectionIcons[section] || '•'}</span>
        <span class="edu-category__copy"><strong>${esc(section)}</strong>${permanentBadge}<small>${meta}</small></span>
      </button>`;
    }).join('');

    sectionWrap.querySelectorAll('[data-section]').forEach(button => {
      button.addEventListener('click', () => {
        const section = button.dataset.section;

        /*
          MAIN CARDS
          ----------
          Clicking a new card ADDS that filter instead of replacing the existing ones.
          Only the most recently clicked section is expanded below, so the page stays compact.
          Previously selected sections remain visibly active (green) and can be removed from
          the active-filter chips above the lesson list, or with Reset filtri.
        */
        if (activeSections.has(section)) {
          // Clicking an already selected main card toggles it OFF completely:
          // remove its green overlay, its detail filters and its open submenu.
          activeSections.delete(section);
          activeDetails.delete(section);
          if (detailSection === section) detailSection = null;
        } else {
          activeSections.add(section);
          detailSection = section === 'Biblioteca' ? null : section;
        }

        visibleLimit = 24;
        renderSections();
        renderDetails();
        renderGrid();
      });
    });
  }

  function renderDetails() {
    /*
      Keep only the LAST clicked expandable section open.
      Other active sections stay selected in the main cards and remain visible
      in the active-filter summary above the lessons. This avoids long stacks
      of submenus when several filters are combined.
    */
    if (!detailSection || !activeSections.has(detailSection) || detailSection === 'Biblioteca') {
      detailPanel.hidden = true;
      detailChips.innerHTML = '';
      return;
    }

    const section = detailSection;
    const selected = detailsFor(section);

    if (section === 'Percorsi') {
      detailTitle.textContent = 'Percorsi';
      detailHint.textContent = 'Seleziona uno o più percorsi da combinare con gli altri filtri.';

      const codes = Object.keys(DATA.paths || {}).filter(code => lessons.some(x => x.paths?.includes(code)));
      detailChips.innerHTML = `<div class="edu-detail-group"><div class="edu-detail-group__chips">${codes.map(code => {
        const path = DATA.paths[code];
        const n = lessons.filter(x => x.paths?.includes(code)).length;
        return `<button class="edu-subcategory-chip ${selected.has(code) ? 'is-active' : ''}" type="button" data-detail-section="Percorsi" data-detail="${esc(code)}" aria-pressed="${selected.has(code)}">${esc(path.name)} <small>${n}</small></button>`;
      }).join('')}</div></div>`;
    } else {
      detailTitle.textContent = section;
      detailHint.textContent = 'Seleziona una o più sottocategorie per affinare i risultati.';

      const values = [...new Set(
        lessons.filter(x => x.category === section).map(x => x.subcategory).filter(Boolean)
      )];
      values.sort((a, b) => {
        const ai = preferredSubcategories.indexOf(a);
        const bi = preferredSubcategories.indexOf(b);
        return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
      });

      detailChips.innerHTML = `<div class="edu-detail-group"><div class="edu-detail-group__chips">${values.map(value => {
        const n = lessons.filter(x => x.category === section && x.subcategory === value).length;
        return `<button class="edu-subcategory-chip ${selected.has(value) ? 'is-active' : ''}" type="button" data-detail-section="${esc(section)}" data-detail="${esc(value)}" aria-pressed="${selected.has(value)}">${esc(value)} <small>${n}</small></button>`;
      }).join('')}</div></div>`;
    }

    detailPanel.hidden = false;
    detailChips.querySelectorAll('[data-detail]').forEach(button => {
      button.addEventListener('click', () => {
        const section = button.dataset.detailSection;
        const value = button.dataset.detail;
        const selectedNow = detailsFor(section);
        if (selectedNow.has(value)) selectedNow.delete(value);
        else selectedNow.add(value);
        visibleLimit = 24;
        renderDetails();
        renderGrid();
      });
    });
  }

  function filteredLessons() {
    const q = normalize(search.value.trim());

    return lessons.filter(item => {
      const activeAreaSections = areaSections.filter(section => activeSections.has(section));

      // Area di studio: ogni lezione può appartenere ad UNA sola macroarea.
      // Quindi se l'utente ne seleziona più di una, il risultato può essere zero.
      let areaOk = true;
      if (activeAreaSections.length > 0) {
        areaOk = activeAreaSections.every(section => {
          const selectedDetails = activeDetails.get(section) || new Set();
          if (item.category !== section) return false;
          return selectedDetails.size === 0 || [...selectedDetails].every(value => item.subcategory === value);
        });
      }

      let libraryOk = true;
      if (activeSections.has('Biblioteca')) {
        libraryOk = item.library === true;
      }

      let pathsOk = true;
      if (activeSections.has('Percorsi')) {
        const selectedPaths = activeDetails.get('Percorsi') || new Set();
        const itemPaths = Array.isArray(item.paths) ? item.paths : [];
        pathsOk = selectedPaths.size === 0
          ? itemPaths.length > 0
          : [...selectedPaths].every(code => itemPaths.includes(code));
      }

      const pathText = (item.paths || []).map(pathName).join(' ');
      const haystack = normalize([
        item.title,
        item.category,
        item.subcategory,
        pathText,
        item.library ? 'Biblioteca' : ''
      ].filter(Boolean).join(' '));
      const searchOk = !q || haystack.includes(q);

      return areaOk && libraryOk && pathsOk && searchOk;
    });
  }

  function cardBadges(item) {
    const badges = [];
    if (item.library) badges.push('<span class="edu-card__library">Biblioteca</span>');
    (item.paths || []).forEach(code => {
      const path = DATA.paths?.[code];
      if (!path) return;
      const text = contrastText(path.color);
      badges.push(`<span class="edu-card__series" style="--series-color:${esc(path.color)};--series-text:${text}">${esc(path.name)}</span>`);
    });
    return badges.length ? `<span class="edu-card__badges">${badges.join('')}</span>` : '';
  }

  function cardHtml(item) {
    const fallbackCategory = !item.category
      ? ((Array.isArray(item.paths) && item.paths.length > 0) ? 'Percorsi' : (item.library ? 'Biblioteca' : ''))
      : '';
    const metaParts = [item.category || fallbackCategory, item.subcategory].filter(Boolean);
    const metaHtml = metaParts.length
      ? `<span class="edu-card__meta">${metaParts.map((part, index) => `${index ? '<span>•</span>' : ''}<span>${esc(part)}</span>`).join('')}</span>`
      : '';

    return `<a class="edu-card" href="${esc(item.youtubeUrl)}" target="_blank" rel="noopener" aria-label="Apri ${esc(item.title)} su YouTube">
      <span class="edu-card__media"><img src="${esc(item.thumbnail)}" alt="" loading="lazy" width="480" height="270"></span>
      <span class="edu-card__body">
        ${metaHtml}
        ${cardBadges(item)}
        <span class="edu-card__title">${esc(item.title)}</span>
        <span class="edu-card__link">Guarda su YouTube <span aria-hidden="true">↗</span></span>
      </span>
    </a>`;
  }

  function renderActiveFilters() {
    const filters = [];

    sectionOrder.forEach(section => {
      if (!activeSections.has(section)) return;
      filters.push({ type: 'section', section, label: section });
      const details = activeDetails.get(section) || new Set();
      details.forEach(value => {
        filters.push({
          type: 'detail',
          section,
          value,
          label: section === 'Percorsi' ? pathName(value) : value
        });
      });
    });

    const query = search.value.trim();
    if (query) filters.push({ type: 'search', label: `Cerca: ${query}` });

    if (!filters.length) {
      activeFilters.hidden = true;
      activeFiltersList.innerHTML = '';
      return;
    }

    activeFilters.hidden = false;
    activeFiltersList.innerHTML = filters.map((filter, index) =>
      `<button type="button" class="edu-active-filter" data-filter-index="${index}"><span>${esc(filter.label)}</span><span class="edu-active-filter__x" aria-hidden="true">×</span><span class="visually-hidden">Rimuovi filtro ${esc(filter.label)}</span></button>`
    ).join('');

    activeFiltersList.querySelectorAll('[data-filter-index]').forEach(button => {
      button.addEventListener('click', () => {
        const filter = filters[Number(button.dataset.filterIndex)];
        if (!filter) return;

        if (filter.type === 'section') {
          activeSections.delete(filter.section);
          activeDetails.delete(filter.section);
          if (detailSection === filter.section) detailSection = null;
        } else if (filter.type === 'detail') {
          activeDetails.get(filter.section)?.delete(filter.value);
        } else if (filter.type === 'search') {
          search.value = '';
        }

        visibleLimit = 24;
        renderSections();
        renderDetails();
        renderGrid();
      });
    });
  }

  function updateResetState() {
    const hasDetailFilters = [...activeDetails.values()].some(set => set.size > 0);
    const hasFilters = activeSections.size > 0 || hasDetailFilters || search.value.trim() !== '';
    reset.disabled = !hasFilters;
    reset.classList.toggle('is-disabled', !hasFilters);
  }

  function renderGrid() {
    const filtered = filteredLessons();
    const visible = filtered.slice(0, visibleLimit);
    grid.innerHTML = visible.map(cardHtml).join('');
    count.textContent = filtered.length;
    empty.hidden = filtered.length !== 0;

    const remaining = Math.max(filtered.length - visible.length, 0);
    const nextCount = Math.min(LOAD_STEP, remaining);
    if (remaining <= 0) {
      more.hidden = true;
      more.disabled = true;
      more.textContent = '';
    } else {
      more.hidden = false;
      more.disabled = false;
      more.textContent = `Mostra altre ${nextCount} ${nextCount === 1 ? 'lezione' : 'lezioni'}`;
    }

    renderActiveFilters();
    updateResetState();
  }

  search.addEventListener('input', () => {
    visibleLimit = 24;
    renderGrid();
  });

  more.addEventListener('click', () => {
    visibleLimit += LOAD_STEP;
    renderGrid();
  });

  function resetAllFilters() {
    activeSections.clear();
    activeDetails.clear();
    detailSection = null;
    visibleLimit = 24;
    search.value = '';
    renderSections();
    renderDetails();
    renderGrid();
  }

  reset.addEventListener('click', resetAllFilters);
  if (emptyReset) emptyReset.addEventListener('click', resetAllFilters);

  function renderPath() {
    if (!pathList) return;
    const ids = (pathList.dataset.videoIds || '').split(',').map(x => x.trim()).filter(Boolean);
    const selected = ids.map(id => lessons.find(x => x.video === id)).filter(Boolean);
    if (!selected.length) {
      const wrapper = pathList.closest('.edu-path');
      if (wrapper) wrapper.hidden = true;
      return;
    }
    pathList.innerHTML = selected.map((item, i) => {
      const meta = [item.category, item.subcategory].filter(Boolean).map(esc).join(' · ');
      return `<a class="edu-path__item" href="${esc(item.youtubeUrl)}" target="_blank" rel="noopener"><span class="edu-path__num">${String(i + 1).padStart(2, '0')}</span><span><strong>${esc(item.title)}</strong>${meta ? `<small>${meta}</small>` : ''}</span><span class="edu-path__arrow">↗</span></a>`;
    }).join('');
  }

  renderSections();
  renderDetails();
  renderGrid();
  renderPath();
})();
